<template>
  <div class="detailDiv">
    <div class="contentDiv">
      <div class="goBackDiv">
        <div class="goBack" @click="goBack">返回</div>
      </div>

      <div class="contentBox">
        <div class="detailTitle">
          {{
            achieving == 0
              ? "非成果方：项目合作服务申请登记表"
              : "成果方：成果延伸服务申请登记表"
          }}
        </div>

        <div class="formContent">
          <div class="tabDiv" v-if="achieving == 0">
            <div
              class="tabItem0"
              :class="{ activeTab: activeTab === 1 }"
              @click="handleTabClick(1)"
            >
              资本合作
            </div>
            <div
              class="tabItem0"
              :class="{ activeTab: activeTab === 2 }"
              @click="handleTabClick(2)"
            >
              技术合作
            </div>
            <div
              class="tabItem0"
              :class="{ activeTab: activeTab === 3 }"
              @click="handleTabClick(3)"
            >
              产业合作
            </div>
            <div
              class="tabItem0"
              :class="{ activeTab: activeTab === 4 }"
              @click="handleTabClick(4)"
            >
              市场合作
            </div>
          </div>
          <div class="tabDiv" v-if="achieving == 1">
            <div
              class="tabItem1"
              :class="{ activeTab: activeTab === 1 }"
              @click="handleTabClick(1)"
            >
              精准化供需对接推介活动
            </div>
            <div
              class="tabItem1"
              :class="{ activeTab: activeTab === 2 }"
              @click="handleTabClick(2)"
            >
              专业化诊断评价策划业务
            </div>
            <div
              class="tabItem1"
              :class="{ activeTab: activeTab === 3 }"
              @click="handleTabClick(3)"
            >
              数字化云网智能服务平台
            </div>
            <div
              class="tabItem1"
              :class="{ activeTab: activeTab === 4 }"
              @click="handleTabClick(4)"
            >
              常态化共建科创实体机构
            </div>
            <div
              class="tabItem1"
              :class="{ activeTab: activeTab === 5 }"
              @click="handleTabClick(5)"
            >
              生态化落地项目育成工场
            </div>
          </div>

          <div class="tabContent">
            <el-form
              label-width="60px"
              :model="formData"
              size="small"
              :rules="rules"
              ref="loginForm"
            >
              <div v-if="achieving == 0">
                <div v-if="activeTab == 1" class="tabContentDiv">
                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>项目股权投资</span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.equity_investment">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>
                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>项目金融信贷 </span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.financial_credit">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>
                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>项目并购合作 </span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.merger_acquisition">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>

                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>项目融资代理 </span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.financing_agency">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>

                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>项目上市运作 </span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.listing_operation">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>
                  <div></div>
                </div>

                <div v-if="activeTab == 2" class="tabContentDiv">
                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>技术专家顾问咨询</span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.consulting">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>
                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>技术中心合作共建 </span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.joint_construction">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>
                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>技术项目合作研发 </span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.research_development">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>
                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>技术成果转移交易 </span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.transfer_transaction">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>
                  <div></div>
                </div>
                <div v-if="activeTab == 3" class="tabContentDiv">
                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>产业资源供给</span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.resource_supply">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>

                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>产业链条配套 </span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.chain_matching">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>

                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>产业园区招商 </span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.attract_investment">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>

                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>产业政策扶持 </span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.policy_support">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>

                  <div></div>
                </div>
                <div v-if="activeTab == 4" class="tabContentDiv">
                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>市场战略规划设计</span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.plan_design">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>

                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>产品市场包装宣传 </span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.packaging_promotion">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>
                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>应用场景拓展开发 </span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.expand_development">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>

                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>产品销售渠道代理 </span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.channel_agent">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>

                  <div></div>
                </div>
              </div>
              <div v-if="achieving == 1">
                <div v-if="activeTab == 1" class="tabContentDiv">
                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>定向推介活动</span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.directional">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>
                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>专项推介活动</span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.special">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>
                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>专题推介活动 </span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.special_subject">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>
                </div>

                <div v-if="activeTab == 2" class="tabContentDiv">
                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>项目过滤筛选</span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.filter">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>
                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>项目对接撮合</span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.matchmaking">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>
                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>项目策划促进</span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.planning_promotion">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>
                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>项目落地平台</span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.landing_platform">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>
                </div>
                <div v-if="activeTab == 3" class="tabContentDiv">
                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>数字化云网智能服务平台</span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.digitized_cloud">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>

                </div>
                <div v-if="activeTab == 4" class="tabContentDiv">
                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>地区合作机构</span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.regional">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>

                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>行业合作机构</span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.industry">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>
                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>国际合作机构</span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.international">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>
                </div>

                <div v-if="activeTab == 5" class="tabContentDiv">
                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>资本市场投资</span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.capital_market">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>

                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>产业园区招商 </span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.investment_promotion">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>
                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>地区经济产业 </span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.economic_industry">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>

                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>大型企业重大 </span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.large_enterprises">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>

                  <el-card class="tabContentOne">
                    <div slot="header" class="clearfix">
                      <span>中小企业跃升 </span>
                    </div>
                    <div>
                      <el-radio-group v-model="formData.medium_sized">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </el-card>
                </div>
              </div>

              <div class="formContentDiv">
                <el-form-item
                  label="单位:"
                  prop="contacts_org"
                  style="margin-bottom: 25px"
                >
                  <el-input
                    v-model="formData.contacts_org"
                    placeholder="请输入你的单位名称"
                  ></el-input>
                </el-form-item>
                <el-row type="flex" justify="space-between">
                  <el-col :span="7">
                    <el-form-item label="职务:" prop="contacts_position">
                      <el-input
                        v-model="formData.contacts_position"
                        placeholder="请输入你的职务"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="7">
                    <el-form-item label="姓名:" prop="contacts_name">
                      <el-input
                        v-model="formData.contacts_name"
                        placeholder="请输入你的姓名"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="7">
                    <el-form-item label="电话:" prop="contacts_phone">
                      <el-input
                        v-model="formData.contacts_phone"
                        placeholder="请输入你的电话"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <div class="btnDiv">
                <!-- 按钮 -->

                <div class="cancelDiv" @click="goBack">取消</div>
                <div class="confirmDiv" @click="handleSubmit">
                  确认提交延伸服务申请
                </div>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "applyForm",

  data() {
    return {
      searchKeyword: "",
      item: {},
      achieving: "",
      formData: {
        project_item_id: "",
        project_contacts_type: "",
        // 成果方服务 (Tab 1)
        directional: "", // 定向推介活动
        special: "", // 专项推介活动
        special_subject: "", // 专题推介活动
        // 成果方服务 (Tab 2)
        filter: "", // 项目过滤筛选
        matchmaking: "", // 项目对接撮合
        planning_promotion: "", // 项目策划促进
        landing_platform: "", // 项目落地平台
        // 成果方服务 (Tab 3)
        digitized_cloud: "", // 数字化云网智能服务平台
        // 成果方服务 (Tab 4)
        regional: "", // 地区合作机构
        industry: "", // 行业合作机构
        international: "", // 国际合作机构
        // 成果方服务 (Tab 5)
        capital_market: "", // 资本市场投资
        investment_promotion: "", // 产业园区招商
        economic_industry: "", // 地区经济产业
        large_enterprises: "", // 大型企业重大
        medium_sized: "", // 中小企业跃升
        // 资本合作
        equity_investment: "", // 项目股权投资
        financial_credit: "", // 项目金融信贷
        merger_acquisition: "", // 项目并购合作
        financing_agency: "", // 项目融资代理
        listing_operation: "", // 项目上市运作
        // 技术合作
        consulting: "", // 技术专家顾问咨询
        joint_construction: "", // 技术中心合作共建
        research_development: "", // 技术项目合作研发
        transfer_transaction: "", // 技术成果转移交易
        // 产业合作
        resource_supply: "", // 产业资源供给
        chain_matching: "", // 产业链条配套
        attract_investment: "", // 产业园区招商
        policy_support: "", // 产业政策扶持
        // 市场合作
        plan_design: "", // 市场战略规划设计
        packaging_promotion: "", // 产品市场包装宣传
        expand_development: "", // 应用场景拓展开发
        channel_agent: "", // 产品销售渠道代理
        // 成果方服务 (原有字段)
        directional_promotion: "", // 定向推介活动
        project_filter: "", // 项目过滤筛选
        project_matching: "", // 项目对接撮合
        project_planning: "", // 项目策划促进
        project_platform: "", // 项目落地平台
        digital_platform: "", // 数字化云网智能服务平台
        regional_cooperation: "", // 地区合作机构
        industry_cooperation: "", // 行业合作机构
        international_cooperation: "", // 国际合作机构
        industrial_park: "", // 产业园区招商
        regional_economy: "", // 地区经济产业
        large_enterprise: "", // 大型企业重大
        smes_upgrade: "", // 中小企业跃升
        // 联系信息
        contacts_org: "", // 单位
        contacts_position: "", // 职务
        contacts_name: "", // 姓名
        contacts_phone: "", // 电话
      },
      rules: {
        contacts_org: [
          { required: true, message: "请输入单位名称", trigger: "blur" },
        ],
        contacts_position: [
          { required: true, message: "请输入职务", trigger: "blur" },
        ],
        contacts_name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        contacts_phone: [
          { required: true, message: "请输入电话", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
      },
      activeTab: 1,
    };
  },
  mounted() {
    const data = this.$route.query.item;
    this.item = JSON.parse(data);
    this.achieving = this.$route.query.achieving;
  },
  methods: {
    handleSubmit() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          if (this.item.id) {
            this.formData.project_item_id = this.item.id;
            this.formData.project_contacts_type = this.achieving == 0 ? 1 : 2;
          }
          this.formData.cooperate_type =this.achieving == 0 ? this.activeTab : 0;
          this.formData.extend_type = this.achieving == 1 ? this.activeTab : 0;
          console.log("表单数据:", this.formData);
          this.$API.saveProjectContacts(this.formData).then((res) => {
            this.$message.success("提交成功");
            this.resetForm();
            this.activeTab = 1;
            this.goBack()
          });
        } else {
          this.$message.error("请填写完整信息");
          return false;
        }
      });
    },
            resetForm() {
            const keys = Object.keys(this.formData)
            keys.forEach(key => {
                this.formData[key] = ''
            })
            this.$refs.loginForm.resetFields()
        },
    handleTabClick(tab) {
      this.activeTab = tab;
    },
    goBack() {
      this.$router.push({
        path: "/AchievementDetail",
        query: { id: this.$route.query.id, data: JSON.stringify(this.item) },
      });
    },
  },
};
</script>

<style scoped>
.btnDiv {
  display: flex;
  justify-content: center;
  margin-top: 200px;
  margin-bottom: 40px;
}
.confirmDiv {
  width: 224px;
  height: 50px;
  background: linear-gradient(134deg, #0366f1 0%, #4b93f0 100%);
  border-radius: 4px 4px 4px 4px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  line-height: 50px;
  text-align: center;
  margin-left: 20px;
  cursor: pointer;
}
.cancelDiv {
  width: 80px;
  height: 50px;
  background: #ffffff;
  border-radius: 3px 3px 3px 3px;
  border: 1px solid #0366f1;

  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 16px;
  color: #444444;
  line-height: 50px;
  text-align: center;
  cursor: pointer;
}
.formContentDiv {
  padding: 0 50px;
  margin-top: 40px;
}
.tabContentDiv {
  display: flex;
  justify-content: space-between;
  padding: 0 50px;
}
.tabContentOne {
  width: 260px;
  height: 123px;
  background: url("../../../assets/cgListBg1.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 4px;
  margin-right: 15px;
}
.tabItem0 {
  width: 25%;
  height: 56px;
  background: #fff;
  border-radius: 4px 4px 4px 4px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 16px;
  color: #444444;
  line-height: 56px;
  text-align: center;
  cursor: pointer;
}
.tabItem1 {
  width: 20%;
  height: 56px;
  background: #fff;
  border-radius: 4px 4px 4px 4px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 16px;
  color: #444444;
  line-height: 56px;
  text-align: center;
  cursor: pointer;
}

.activeTab {
  background: linear-gradient(134deg, #11a1fd 0%, #4ac4fb 100%);
  color: #fff;
}

.tabDiv {
  display: flex;
  border-bottom: 1px solid #d2d3d5;
  margin-bottom: 40px;
}
.formContent {
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #e3e5e6;
}
.buttonBtn {
  display: flex;
  justify-content: space-around;
  margin-top: 150px;
}
.mt5 {
  margin-top: 5px;
}

.rightBtn {
  width: 250px;
  height: 90px;
  background: linear-gradient(134deg, #11a1fd 0%, #4ac4fb 100%);
  border-radius: 4px 4px 4px 4px;
  text-align: center;

  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: bold;
  font-size: 18px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.leftBtn {
  width: 250px;
  height: 90px;
  background: linear-gradient(134deg, #0366f1 0%, #4b93f0 100%);
  border-radius: 4px 4px 4px 4px;
  text-align: center;

  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: bold;
  font-size: 18px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.htmlDiv {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 16px;
  color: #5e6a7a;
  margin-top: 15px;
}
.topDiv {
  border-bottom: 1px solid #eeeeee;
  padding-bottom: 30px;
  margin-bottom: 30px;
}
.mr120 {
  margin-right: 100px;
}
.w700 {
  width: 650px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.baseLeft {
  width: 543px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 16px;
  color: #a5a5a5;
  line-height: 30px;
}
.infoDetail {
  display: flex;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 16px;
  color: #444444;
  margin-top: 15px;
}
.d1 {
  width: 93px;
  height: 24px;
}
.detailTitle {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: bold;
  font-size: 24px;
  color: #444444;
  text-align: center;
  margin-bottom: 40px;
}
.contentBox {
  background: #fff;
  border-radius: 4px;
  padding: 40px 80px 80px 80px;
  margin-bottom: 30px;
}
.goBackDiv {
  display: flex;
  justify-content: end;
}
.goBack {
  width: 65px;
  height: 36px;
  background: #f2fbff;
  border-radius: 3px 3px 3px 3px;

  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #0366f1;
  line-height: 36px;
  text-align: center;
  margin: 20px 0;
  cursor: pointer;
}
.detailDiv {
  min-height: calc(100vh - 230px);
  background-image: url("../../../assets/bg222.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  position: relative;
}
.contentDiv {
  width: 1200px;
  margin: 0 auto;
}
</style>
